import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/components/dom/max-width-container.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Heading","Paragraph"] */ "/usr/src/app/components/dom/text-elements.tsx");
